import styled from "styled-components";

export const HeaderWrapper = styled.div`
    margin: 15px 0;
    text-align: center;
`;